import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col, Checkbox, Affix, Alert } from 'antd';
import classNames from 'classnames';

import * as pageActions from '../../../../../../data/redux/page_details/actions';
import * as teamMemberSettingActions from '../../../../../../data/redux/team_member_setting_details/actions';

import { APP_PAGES, ROUTE_PATH, APP_LAYOUT, PERMISSIONS } from '../../../../../../data/config/constants';
import { showMessage } from '../../../../../../data/config/utils';
import { MODULE_MESSAGE } from '../../../../../../data/config/urls';

import PageHeaderLoader from '../../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../../components/loaders/cardrowtable';
import AvatarCardLoader from '../../../../../../components/avatarcard/loader';
import AvatarCard from '../../../../../../components/avatarcard'
import ModalFooter from '../../../../../../components/modalfooter';
import SwitchItem from '../../../../../../components/form/switchitem';
import CustomHeader from '../../../../../../components/customheader';
import ShowMessage from '../../../../../../components/showmessage';

class MemberPermissions extends Component {
    componentWillMount() {
        this.props.actions.pageChanged(APP_PAGES.MEMBER_PERMISSIONS, APP_PAGES.SETTINGS);
    }

    componentDidMount() {
        const { actions, match, history } = this.props;
        if (match && match.params && match.params.memberId) {
            const payload = { id: match.params.memberId };
            actions.getUserPermissions(payload);
        } else {
            showMessage('error', 'member id is missing in params.');
            history.goBack();
        }
    }

    cancelMemberPermissionUpdation = () => {
        const { history, actions } = this.props;
        history.push(ROUTE_PATH.TEAM_MEMBER_SETTING);
        actions.updateSettingState({}, 'current_member_permissions');
    };

    updateMemberPermissions = () => {
        const { actions, team_member_setting_details, isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.TEAM_MANAGEMENT, PERMISSIONS.ACTION_TYPES.UPDATE)) {
            const payload = team_member_setting_details.current_member_permissions;
            actions.updateUserPermissions(payload, this.cancelMemberPermissionUpdation);
        } else {
            showMessage('warning', "you have not access to update member's permission.");
        }
    };

    render() {
        const { isActionPermitted, admin_details, page_details, team_member_setting_details, actions } = this.props;
        const avatar_card_top_offset = APP_LAYOUT.APP_HEADER_HEIGHT + 12;
        const mobile = page_details.device_data.screen_width < 768;
        const is_self_account = admin_details.admin_id === team_member_setting_details.current_member_permissions.psid;
        const is_update_allowed = is_self_account ? false : isActionPermitted(PERMISSIONS.ACTIONS.TEAM_MANAGEMENT, PERMISSIONS.ACTION_TYPES.UPDATE);

        if (team_member_setting_details.loaders.user_permission_loading && !team_member_setting_details.loaders.user_permission_loaded) {
            return (
                <Row className="ori-bg-default">
                    <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 7, offset: 0 }} className="ori-pad-10">
                        <div className="ori-bg-white ori-box-shadow-light ori-lr-pad-10 ori-tb-pad-20">
                            <AvatarCardLoader />
                        </div>
                    </Col>
                    <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 17, offset: 0 }} className="ori-lr-pad-10">
                        <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
                        <CardRowTableLoader />
                    </Col>
                </Row>
            );
        } else if (!team_member_setting_details.loaders.user_permission_loading && team_member_setting_details.loaders.user_permission_loaded) {
            return (
                <Row className="ori-bg-default">
                    <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 7, offset: 0 }} className="ori-pad-10">
                        <Affix offsetTop={avatar_card_top_offset} className={classNames({ "ori-affix-block": mobile })}>
                            <div className="ori-bg-white ori-box-shadow-light ori-lr-pad-10 ori-tb-pad-20">
                                <AvatarCard show_status show_sociallinks avatar_class="ori-box-75" title_class="ori-font-md ori-text-center" sub_title_class="ori-font-sm ori-font-light ori-text-center" title={`${team_member_setting_details.current_member_permissions.firstName} ${team_member_setting_details.current_member_permissions.lastName}`} sub_title={team_member_setting_details.current_member_permissions.designation} email={team_member_setting_details.current_member_permissions.email} is_verified={team_member_setting_details.current_member_permissions.isVerified} is_active={team_member_setting_details.current_member_permissions.isActive} is_deleted={team_member_setting_details.current_member_permissions.isDeleted} bio={team_member_setting_details.current_member_permissions.bio} facebook_url={team_member_setting_details.current_member_permissions.socialLinks ? team_member_setting_details.current_member_permissions.socialLinks.facebook : null} twitter_url={team_member_setting_details.current_member_permissions.socialLinks ? team_member_setting_details.current_member_permissions.socialLinks.twitter : null} linkedin_url={team_member_setting_details.current_member_permissions.socialLinks ? team_member_setting_details.current_member_permissions.socialLinks.linkedin : null} />
                            </div>
                        </Affix>
                    </Col>
                    <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 17, offset: 0 }} className="ori-lr-pad-10">
                        <CustomHeader title="Member Permissions" first_button_text="Cancel" onClickFirstButton={this.cancelMemberPermissionUpdation} second_button_type="primary" second_button_text="Save" second_button_loading={team_member_setting_details.loaders.user_permission_updating} onClickSecondButton={this.updateMemberPermissions} show_second_button={is_update_allowed} bottom_bordered show_first_button />
                        {
                            !is_update_allowed &&
                            <Alert className="ori-t-mrgn-10" message="Informational Note" description={is_self_account ? MODULE_MESSAGE.SETTINGS.TEAM_MEMBER_SETTING.MEMBER_PERMISSIONS.self_account : MODULE_MESSAGE.SETTINGS.TEAM_MEMBER_SETTING.MEMBER_PERMISSIONS.not_access} type="info" showIcon closable />
                        }
                        {
                            team_member_setting_details.current_member_permissions &&
                            team_member_setting_details.current_member_permissions.permissions && team_member_setting_details.current_member_permissions.permissions.features &&
                            <Col xs={24} className="ori-tb-mrgn-10">
                                <div className="ori-font-lg ori-tb-mrgn-5">Features Permission</div>
                                {
                                    Object.keys(team_member_setting_details.current_member_permissions.permissions.features).map((key, index) => {
                                        return (
                                            <div key={index} className="ori-bg-white ori-tb-mrgn-5 ori-box-shadow-light">
                                                <div className="ori-pad-10">
                                                    <SwitchItem hide_switch={!team_member_setting_details.current_member_permissions.permissions.features[key].editable} disabled={!is_update_allowed} title={team_member_setting_details.current_member_permissions.permissions.features[key].appPage} checked={team_member_setting_details.current_member_permissions.permissions.features[key].isAllowed} switch_text={team_member_setting_details.current_member_permissions.permissions.features[key].isAllowed ? "ENABLE" : "DISABLE"} onChange={(bool) => actions.updateSettingState(bool, `current_member_permissions.permissions.features.${key}.isAllowed`)} />
                                                </div>
                                                {
                                                    team_member_setting_details.current_member_permissions.permissions.features[key].isAllowed && team_member_setting_details.current_member_permissions.permissions.features[key].children &&
                                                    <div className="ori-animated ori-fade-in ori-lr-pad-15 ori-tb-pad-10 ori-t-border-light">
                                                        {
                                                            Object.keys(team_member_setting_details.current_member_permissions.permissions.features[key].children).map((child_key, child_index) => {
                                                                return (
                                                                    <div key={child_index} className="ori-lr-pad-5">
                                                                        <Checkbox disabled={!is_update_allowed || !team_member_setting_details.current_member_permissions.permissions.features[key].children[child_key].editable} checked={team_member_setting_details.current_member_permissions.permissions.features[key].children[child_key].isAllowed} onChange={(e) => actions.updateSettingState(e.target.checked, `current_member_permissions.permissions.features.${key}.children.${child_key}.isAllowed`)} /> <span className="ori-capitalize">{team_member_setting_details.current_member_permissions.permissions.features[key].children[child_key].appPage}</span>
                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        );
                                    })
                                }
                            </Col>
                        }
                        {
                            team_member_setting_details.current_member_permissions &&
                            team_member_setting_details.current_member_permissions.permissions && team_member_setting_details.current_member_permissions.permissions.actions &&
                            <Col xs={24} className="ori-tb-mrgn-10">
                                <div className="ori-font-lg ori-tb-mrgn-5">Actions Permission</div>
                                <div className="ori-full-width ori-overflow-x-auto">
                                    <table className="ori-full-width ori-bg-white ori-box-shadow-light">
                                        <thead>
                                            <tr className="ori-bg-primary ori-font-white">
                                                <th className="ori-lr-pad-15 ori-tb-pad-10">Action</th>
                                                <th className="ori-lr-pad-15 ori-tb-pad-10 ori-text-center">Create</th>
                                                <th className="ori-lr-pad-15 ori-tb-pad-10 ori-text-center">Update</th>
                                                <th className="ori-lr-pad-15 ori-tb-pad-10 ori-text-center">Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Object.keys(team_member_setting_details.current_member_permissions.permissions.actions).map((key, index) => {
                                                    if (team_member_setting_details.current_member_permissions.permissions.actions[key].display) {
                                                        return (
                                                            <tr key={index} className="ori-b-border-default ori-bg-white-hover-primary-light">
                                                                <td className="ori-lr-pad-15 ori-tb-pad-10 ori-font-bold">{key}</td>
                                                                <td className="ori-lr-pad-15 ori-tb-pad-10 ori-text-center">
                                                                    <Checkbox disabled={!is_update_allowed} checked={team_member_setting_details.current_member_permissions.permissions.actions[key].create} onChange={(e) => actions.updateSettingState(e.target.checked, `current_member_permissions.permissions.actions.${key}.create`)} />
                                                                </td>
                                                                <td className="ori-lr-pad-15 ori-tb-pad-10 ori-text-center">
                                                                    <Checkbox disabled={!is_update_allowed} checked={team_member_setting_details.current_member_permissions.permissions.actions[key].update} onChange={(e) => actions.updateSettingState(e.target.checked, `current_member_permissions.permissions.actions.${key}.update`)} />
                                                                </td>
                                                                <td className="ori-lr-pad-15 ori-tb-pad-10 ori-text-center">
                                                                    <Checkbox disabled={!is_update_allowed} checked={team_member_setting_details.current_member_permissions.permissions.actions[key].delete} onChange={(e) => actions.updateSettingState(e.target.checked, `current_member_permissions.permissions.actions.${key}.delete`)} />
                                                                </td>
                                                            </tr>
                                                        );
                                                    } else {
                                                        return null;
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Col>
                        }
                        {
                            team_member_setting_details.current_member_permissions &&
                            team_member_setting_details.current_member_permissions.permissions && team_member_setting_details.current_member_permissions.permissions.events &&
                            <Col xs={24} className="ori-tb-mrgn-10">
                                <div className="ori-font-lg ori-tb-mrgn-5">Events Permission</div>
                                {
                                    Object.keys(team_member_setting_details.current_member_permissions.permissions.events).map((key, index) => {
                                        return (
                                            <div key={index} className="ori-bg-white ori-pad-10 ori-tb-mrgn-5">
                                                <SwitchItem title={key} disabled={!is_update_allowed} checked={team_member_setting_details.current_member_permissions.permissions.events[key]} switch_text={team_member_setting_details.current_member_permissions.permissions.events[key] ? "ENABLE" : "DISABLE"} onChange={(bool) => actions.updateSettingState(bool, `current_member_permissions.permissions.events.${key}`)} />
                                            </div>
                                        );
                                    })
                                }
                            </Col>
                        }
                    </Col>
                    <Col xs={24} className="ori-tb-pad-10">
                        <ModalFooter capsule_button loading={team_member_setting_details.loaders.user_permission_updating} hide_ok_button={!is_update_allowed} button_ok_text="save" handleCancelClick={this.cancelMemberPermissionUpdation} handleOkClick={this.updateMemberPermissions} />
                    </Col>
                </Row>
            );
        } else if (!team_member_setting_details.loaders.user_permission_loading && !team_member_setting_details.loaders.user_permission_loaded) {
            return (
                <ShowMessage title="Error" message="unable to fetch member permissions. please check your internet connection and reload the page." height={150} width={150} error />
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
        admin_details: state.admin_details,
        team_member_setting_details: state.team_member_setting_details
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, teamMemberSettingActions), dispatch)
    };
}

MemberPermissions.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    admin_details: PropTypes.object,
    team_member_setting_details: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(MemberPermissions);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/settings/teammembersetting/memberpermissions/index.js